import React, { useEffect, useState } from "react";

function ImageWithLoader({ src, children }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.onload = () => setIsLoaded(true);
    image.src = src;
  }, []);

  return isLoaded ? <img src={src} /> : <>{children}</>;
}

export default ImageWithLoader;
